require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-t-vi-ro.json") })
        }
      }, "path---photos-professional-t-vi-ro");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-t-vi-ro!./.cache/json/photos-professional-t-vi-ro.json
// module id = 906
// module chunks = 231608221292675